'use client';

import { ComboboxItem } from "../../combobox/item/ComboboxItem.mjs";
/**
 * An individual item in the list.
 * Renders a `<div>` element.
 *
 * Documentation: [Base UI Autocomplete](https://base-ui.com/react/components/autocomplete)
 */
export const AutocompleteItem = ComboboxItem;